import { FaqDisclosureList } from '../resources/FaqDisclosureList';
import { organizationFaqs } from '../resources/faqData';

export const FAQ = () => {
  return (
    <section className="bg-white border-t border-grey-800">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-24 lg:px-8">
        <div className="mx-auto max-w-4xl text-left">
          <p className="text-sm font-semibold uppercase leading-6 tracking-normal text-primary-50">
            Organization FAQ
          </p>
          <h2 className="mt-3 text-4xl font-semibold tracking-tight text-grey-100 sm:text-5xl">
            Common organization questions
          </h2>
          <p className="mt-6 text-lg leading-8 text-grey-300">
            How the platform supports provider recruiting, credential-aware hiring, onboarding,
            compliance readiness, and workforce intelligence.
          </p>
          <div className="mt-12">
            <FaqDisclosureList items={organizationFaqs} />
          </div>
        </div>
      </div>
    </section>
  );
};
